'use client'

import { useSocial, useUserStore } from '@utsubo/experience'
import { useStoreUI, getStoreUI } from '@utsubo/ui'
import { useSessionLogs } from '../useSessionLogs'
import { useLogsReport } from '../useLogsReport'
import { emitEvent } from '@utsubo/events'
import dynamic from 'next/dynamic'
import { useEffect } from 'react'

const UI = dynamic(() => import('@utsubo/ui').then((mod) => mod.UI), {
  ssr: false,
})

export const ClientUiWrapper = ({ children, workspace, microverse }) => {
  // useLogsReport(workspace, microverse)
  // useSessionLogs(workspace, microverse)

  const [id, email] = useUserStore((s) => [s.id, s.email])
  const [allMicroverses] = useStoreUI((s) => [s.allMicroverses])
  const [isElectron, electronReceive, electronSend] = useSocial((s) => [
    s.isElectron,
    s.on,
    s.send,
  ])

  useEffect(() => {
    if (!isElectron) {
      return
    }

    electronReceive('social-sign-out', async () => {
      emitEvent('showSpinnerLoader', { opaque: true })
      await getStoreUI().cleanAndSignout(true)
      window.location.href = '/'
    })

    electronSend('userEmail', { email })
  }, [id, email, isElectron])

  useEffect(() => {
    if (!isElectron) {
      return
    }

    electronSend('listMicroverses', { microverses: allMicroverses })
  }, [id, isElectron, allMicroverses])

  return <UI>{children}</UI>
}
